import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import moment from 'moment';
var offset = 100;

function buildEvent(column, left, width, dayStart) {
  var startTime = moment(column.start);
  var endTime = column.end ? moment(column.end) : startTime.clone().add(1, 'hour');
  var dayStartTime = startTime.clone().hour(dayStart).minute(0);
  var diffHours = startTime.diff(dayStartTime, 'hours', true);
  column.top = diffHours * offset;
  column.height = endTime.diff(startTime, 'hours', true) * offset;
  column.width = width;
  column.left = left;
  return column;
}

function collision(a, b) {
  return a.end > b.start && a.start < b.end;
}

function expand(ev, column, columns) {
  var colSpan = 1;

  for (var i = column + 1; i < columns.length; i++) {
    var col = columns[i];

    for (var j = 0; j < col.length; j++) {
      var ev1 = col[j];

      if (collision(ev, ev1)) {
        return colSpan;
      }
    }

    colSpan++;
  }

  return colSpan;
}

function pack(columns, width, calculatedEvents, dayStart) {
  var colLength = columns.length;

  for (var i = 0; i < colLength; i++) {
    var col = columns[i];

    for (var j = 0; j < col.length; j++) {
      var colSpan = expand(col[j], i, columns);
      var L = i / colLength * width;
      var W = width * colSpan / colLength - 10;
      calculatedEvents.push(buildEvent(col[j], L, W, dayStart));
    }
  }
}

function populateEvents(events, screenWidth, dayStart) {
  var lastEnd;
  var columns;
  var calculatedEvents = [];
  events = events.map(function (ev, index) {
    return _objectSpread({}, ev, {
      index: index
    });
  }).sort(function (a, b) {
    if (a.start < b.start) return -1;
    if (a.start > b.start) return 1;
    if (a.end < b.end) return -1;
    if (a.end > b.end) return 1;
    return 0;
  });
  columns = [];
  lastEnd = null;
  events.forEach(function (ev) {
    if (lastEnd !== null && ev.start >= lastEnd) {
      pack(columns, screenWidth, calculatedEvents, dayStart);
      columns = [];
      lastEnd = null;
    }

    var placed = false;

    for (var i = 0; i < columns.length; i++) {
      var col = columns[i];

      if (!collision(col[col.length - 1], ev)) {
        col.push(ev);
        placed = true;
        break;
      }
    }

    if (!placed) {
      columns.push([ev]);
    }

    if (lastEnd === null || ev.end > lastEnd) {
      lastEnd = ev.end;
    }
  });

  if (columns.length > 0) {
    pack(columns, screenWidth, calculatedEvents, dayStart);
  }

  return calculatedEvents;
}

export default populateEvents;

if (typeof populateEvents !== 'undefined' && populateEvents && populateEvents === Object(populateEvents) && Object.isExtensible(populateEvents) && !populateEvents.hasOwnProperty('__filemeta')) {
  Object.defineProperty(populateEvents, '__filemeta', {
    configurable: true,
    value: {
      name: "populateEvents",
      filename: "node_modules/react-native-calendars/src/timeline/Packer.js"
    }
  });
}